// 防抖函数 - 修复this绑定问题
export function debounce(func, wait, immediate) {
  let timeout;
  return function executedFunction(...args) {
    const context = this; // 保存this上下文
    const later = () => {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    const callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}

// 节流函数 - 修复this绑定问题
export function throttle(func, limit) {
  let inThrottle;
  return function(...args) {
    const context = this; // 保存this上下文
    if (!inThrottle) {
      func.apply(context, args);
      inThrottle = true;
      setTimeout(() => inThrottle = false, limit);
    }
  }
}

// 批量处理函数
export function batchProcess(items, processor, batchSize = 50, delay = 0) {
  return new Promise((resolve) => {
    let index = 0;
    
    function processBatch() {
      const batch = items.slice(index, index + batchSize);
      batch.forEach(processor);
      index += batchSize;
      
      if (index < items.length) {
        setTimeout(processBatch, delay);
      } else {
        resolve();
      }
    }
    
    processBatch();
  });
}